'use client'
import { memo, type PropsWithChildren } from 'react'

export const VaultRiskCurationLayout = memo(({ children }: PropsWithChildren) => {
  return (
    <div
      className="gap-sm flex scroll-mt-[calc(var(--sticky-offset,0px)+16px)] flex-col"
      id="risk-curation-section"
    >
      <span className="text-foreground text-sm">Risk Curation</span>
      {children}
    </div>
  )
})

VaultRiskCurationLayout.displayName = 'VaultRiskCurationLayout'
